import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import CommandPalette from './components/common/CommandPalette';
import PWAInstallBanner from './components/common/PWAInstallBanner';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import AccessibilityPage from './pages/AccessibilityPage';
import AdminRedirect from './pages/AdminRedirect';

function DynamicAdminCatchAll() {
  const { adminSlug } = useLanguage();
  const location = useLocation();
  const pathSegment = location.pathname.replace(/^\/|\/$/g, '').split('/')[0].toLowerCase();
  
  if (adminSlug && adminSlug !== 'admin' && pathSegment === adminSlug.toLowerCase()) {
    return <AdminRedirect />;
  }
  return <NotFound />;
}

function PageTracker() {
  const location = useLocation();
  const { adminSlug } = useLanguage();

  useEffect(() => {
    try {
      if (location.pathname.startsWith('/admin')) return;
      if (adminSlug && adminSlug !== 'admin' && location.pathname.startsWith('/' + adminSlug)) return;

      const payload = JSON.stringify({
        path: location.pathname + location.search,
        referrer: document.referrer || ''
      });

      if (navigator.sendBeacon) {
        navigator.sendBeacon('/api/analytics.php?action=log', new Blob([payload], { type: 'application/json' }));
      } else {
        fetch('/api/analytics.php?action=log', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload,
          keepalive: true
        }).catch(() => {});
      }
    } catch (e) {}
  }, [location.pathname, location.search, adminSlug]);

  return null;
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <CssBaseline />
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <PageTracker />
          <CommandPalette />
          <PWAInstallBanner />
          <Header />
           <Routes>
             <Route exact path="/" element={<Home />} />
             <Route path="/accessibility" element={<AccessibilityPage />} />
             <Route path="/admin" element={<AdminRedirect />} />
             <Route path="/admin/*" element={<AdminRedirect />} />
             <Route path="*" element={<DynamicAdminCatchAll />} />
           </Routes>
          <Footer />
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
